import { Component, Input, OnInit, OnDestroy, HostBinding, OnChanges, SimpleChanges } from '@angular/core';
import { LocalNewsModel } from '../../typings';
import { Constants } from '../../constants';
import { SharedService } from '../../services/shared.service';
import { mvnfbuAnimations } from '../../shared/animations';
@Component({
  selector: 'app-safety-animation',
  templateUrl: './safety-animation.component.html',
  styleUrl: './safety-animation.component.scss',
  standalone: false,
  animations: mvnfbuAnimations
})
export class SafetyAnimationComponent implements OnInit, OnDestroy, OnChanges {
  @Input() currentNews!: LocalNewsModel;
  @Input() animOut!: boolean;
  @HostBinding('class') class = 'fullWith';
  currentImageIndex = 0;
  previousImageIndex = 0;
  isZooming = false;
  isTransitioning = false;
  safetyIconUrl: string = '';
  private carouselTimeout?: number;
  private iconTimeout?: number;
  private readonly timeoutDuration = 6000; // 6 secondes par image

  constructor(private sharedService: SharedService) {}

  ngOnInit(): void {
    console.log('SafetyAnimationComponent initialized with news:', this.currentNews);
    this.initializeCarousel();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['currentNews'] && !changes['currentNews'].firstChange) {
      console.log('News changed, reinitializing carousel');
      this.resetCarousel();
      this.initializeCarousel();
    }
  }

  ngOnDestroy(): void {
    this.stopCarousel();
    if (this.iconTimeout) {
      clearTimeout(this.iconTimeout);
    }
  }

  private initializeCarousel(): void {
    this.isZooming = true; // Démarrer avec l'animation pour la première image
    
    // Charger l'icône avec un délai de 1s
    this.iconTimeout = window.setTimeout(() => {
      this.loadSafetyIcon();
    }, 1000);
    
    if (this.currentNews?.images && this.currentNews.images.length > 1) {
      this.startCarousel();
    }
  }

  private resetCarousel(): void {
    this.stopCarousel();
    this.currentImageIndex = 0;
    this.previousImageIndex = 0;
    this.isZooming = false;
    this.isTransitioning = false;
    
    // Vider l'URL de l'icône pour forcer le rechargement du GIF
    this.safetyIconUrl = '';
    if (this.iconTimeout) {
      clearTimeout(this.iconTimeout);
    }
  }

  private startCarousel(): void {
    this.carouselTimeout = window.setTimeout(() => {
      this.nextImage();
    }, this.timeoutDuration);
  }

  private stopCarousel(): void {
    if (this.carouselTimeout) {
      clearTimeout(this.carouselTimeout);
    }
  }

  nextImage(): void {
    if (this.currentNews?.images) {
      // Déclencher les animations
      this.isZooming = false;
      this.isTransitioning = true;
      
      setTimeout(() => {
        // Mettre à jour les index
        this.previousImageIndex = this.currentImageIndex;
        this.currentImageIndex = (this.currentImageIndex + 1) % this.currentNews.images.length;
        
        // Démarrer le zoom de la nouvelle image
        this.isZooming = true;
        
        // Réinitialiser la transition après l'animation
        setTimeout(() => {
          this.isTransitioning = false;
        }, 1000);
      }, 50);
    }
  }

  get previousImage(): string {
    return this.currentNews?.images?.[this.previousImageIndex] || '';
  }

  get currentImage(): string {
    return this.currentNews?.images?.[this.currentImageIndex] || '';
  }

  get hasMultipleImages(): boolean {
    return this.currentNews?.images && this.currentNews.images.length > 1;
  }

  private loadSafetyIcon(): void {
    if (this.currentNews?.subType) {
      let imageName = Constants.Animations[this.currentNews.subType as keyof typeof Constants.Animations] || this.currentNews.subType;
      imageName = imageName + Constants.Animations.Extension;
      this.safetyIconUrl = this.sharedService.buildUrlBlob(imageName, 'Local-news/animation/safety/');
    }
  }

  getSafetyTypeIcon(arg0: string|null) {
    return this.safetyIconUrl;
  }
}
